(function () {
    'use strict';

    angular
        .module('emails')
        .controller('sendEmailTestController', sendEmailTestController);

    sendEmailTestController.$inject = ['$uibModalInstance', 'campaign', 'CampaignsService', 'toastr'];

    function sendEmailTestController($uibModalInstance, campaign, CampaignsService, toastr) {
        var vm = this;
        vm.campaign = campaign;
        vm.userEmail = [];
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            var query = [];
            query['id'] = vm.campaign.id;
            query['user_email'] = [];
            vm.userEmail.map(function(item){
                query['user_email'].push(item.text);
            });

            CampaignsService.sendEmailTest(query).then(function(response){
                toastr.success('Successfully sent!');
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();